import { colors } from '@lmc/common/constants'
import type { ColorType } from '@lmc/common/types'
import { Typography } from 'antd'
import type { ParagraphProps } from 'antd/lib/typography/Paragraph'
import type { TitleProps } from 'antd/lib/typography/Title'
import React, {
  type CSSProperties,
  type ReactElement,
  type ReactNode
} from 'react'

export const getLineHeight = (as: Ptype | Htype) => {
  let lineHeight

  switch (as) {
    case 'p1':
      lineHeight = '32px'
      break
    default:
      lineHeight = undefined
  }

  return lineHeight
}

export const getParagraphSize = (as: Ptype) => {
  let x = '0px'
  switch (as) {
    case 'p1':
      x = '16px'
      break
    case 'p2':
      x = '14px'
      break
    case 'p3':
      x = '12px'
      break
    default:
      x = '14px'
  }
  return x
}

export const getTitleLevel = (as: Htype) => {
  let x = 1
  switch (as) {
    case 'h1' as Htype:
      x = 1
      break
    case 'h2' as Htype:
      x = 2
      break
    case 'h3' as Htype:
      x = 3
      break
    case 'h4' as Htype:
      x = 4
      break
    case 'h5' as Htype:
      x = 5
      break
    default:
      x = 1
  }
  return x as 1 | 2 | 3 | 4 | 5
}

export type Ptype = 'p1' | 'p2' | 'p3'

export type Htype = 'h1' | 'h2' | 'h3' | 'h4' | 'h5'

export interface TextProps extends TitleProps, ParagraphProps {
  children: ReactNode
  as?: Ptype | Htype
  color?: ColorType
  style?: CSSProperties
  className?: string
}

/**
 * Render text
 * @param as: h1, h2, h3, h4, h5, p1, p2, p3
 * @param style: custom style object
 * @deprecated
 */
const Text = ({
  children,
  as = 'p1',
  style = {},
  color,
  ...props
}: TextProps): ReactElement => {
  const isTitle = ['h1', 'h2', 'h3', 'h4', 'h5'].indexOf(as) !== -1
  // @ts-ignore
  const textStyle = color ? { ...style, color: colors[color] } : style

  return isTitle ? (
    <Typography.Title
      style={{ fontWeight: 700, lineHeight: getLineHeight(as), ...textStyle }}
      level={getTitleLevel(as as Htype)}
      {...props}
    >
      {children}
    </Typography.Title>
  ) : (
    <Typography.Text
      style={{
        ...{
          fontSize: getParagraphSize(as as Ptype),
          lineHeight: getLineHeight(as)
        },
        ...textStyle
      }}
      {...props}
    >
      {children}
    </Typography.Text>
  )
}

export default Text
